<template>
  <div class="toggle">
    <div :class = "{ line: true, active: toggle === true}" @click.prevent="toggle = !toggle">
      <div class="leftSide">
        <img src="../img/openIcon.webp" alt="">
      </div>
      <div class="rightSide">
        <slot name="map"></slot>
      </div>
    </div>
    <div class="wrapper">
      <transition name="slideLine">
      <div class="content" v-if="toggle">
        <slot/>
      </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import {ref} from "vue";

  export default {
    setup() {
      let toggle = ref(false)
      return {
        toggle
      }
    }
  }
</script>

<style scoped>

  .wrapper {
    display: flex;
    justify-content: center;
    overflow: hidden;
    width: 100%;
    height: auto;
  }

  img {
    height: 60px;
    width: 100px;
  }

  .line img {
    transition: transform 1s;
  }

  .line.active img {
    transform: rotate(180deg);
    transition: transform 1s;
  }

  .toggle {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: auto;
  }

  .line {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 10vh;
    cursor: pointer;
  }

  .line:hover {
    border: 7px solid goldenrod;
  }

  .line.active .leftSide {
    background-color: red;
    transition: background-color 1s;
  }

  .leftSide {
    width: 15%;
    background-color: green;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: background-color 1s;
  }
  .rightSide {
    width: 85%;
    background-color: #00008B;
    display: flex;
    align-items: center;
  }

  .slideLine-enter-from {
    max-height: 0;
  }

  .slideLine-enter-to {
    max-height: 100vh;
  }

  .slideLine-leave-from {
    max-height: 100vh;
  }

  .slideLine-leave-to {
    max-height: 0;
  }
  .slideLine-enter-active, .slideLine-leave-active {
    transition:  max-height 1s ease;
  }

  .content {
    display: flex;
    justify-content: center;
    width: 100%;
    height: auto;
  }

  @media (max-width: 1400px) {
    img {
      height: 40px;
      width: 80px;
    }

    .line {
      height: 15vh;
    }
  }

</style>